function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a17"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a17"] = parcelRequire;
}
parcelRequire.register("7nhm9", function(module, exports) {

$parcel$export(module.exports, "updateUnitText", () => $55e824ff15c161b3$export$484c06a51e474327);
$parcel$export(module.exports, "addLeadingZero", () => $55e824ff15c161b3$export$b69ee541cb46e797);
$parcel$export(module.exports, "changeElementsColor", () => $55e824ff15c161b3$export$f0023f0c30a25760);
$parcel$export(module.exports, "changeElementsBorderColor", () => $55e824ff15c161b3$export$34bffb876a6b1142);
$parcel$export(module.exports, "displayFormError", () => $55e824ff15c161b3$export$f7770a2ea49a6643);
$parcel$export(module.exports, "isInputEmpty", () => $55e824ff15c161b3$export$616aab7bda35abc4);
$parcel$export(module.exports, "hideElements", () => $55e824ff15c161b3$export$94ea06b00f779d4b);
$parcel$export(module.exports, "getCurrentDate", () => $55e824ff15c161b3$export$adaf307e533580e2);
$parcel$export(module.exports, "calculateAge", () => $55e824ff15c161b3$export$8ada184d5eef4694);
// HELPER FUNCTIONS

function $55e824ff15c161b3$export$484c06a51e474327(element, value, singularText, pluralText) {
    element.textContent = value === 1 ? singularText : pluralText;
}
function $55e824ff15c161b3$export$b69ee541cb46e797(inputElement) {
    inputElement.value = inputElement.value.padStart(2, "0");
}
function $55e824ff15c161b3$export$f0023f0c30a25760(color, elements) {
    elements.forEach((el)=>{
        el.style.color = color;
    });
}
function $55e824ff15c161b3$export$34bffb876a6b1142(color, elements) {
    elements.forEach((el)=>{
        el.style.borderColor = color;
    });
}
function $55e824ff15c161b3$export$f7770a2ea49a6643(element, error) {
    element.classList.remove("hidden");
    element.textContent = error;
}
function $55e824ff15c161b3$export$616aab7bda35abc4(inputValue) {
    return inputValue === "";
}
function $55e824ff15c161b3$export$94ea06b00f779d4b(elements) {
    if (Array.isArray(elements)) elements.forEach((el)=>{
        el.classList.add("hidden");
    });
    else elements.classList.add("hidden");
}
function $55e824ff15c161b3$export$adaf307e533580e2() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const currentDay = currentDate.getDate();
    return {
        currentDate: currentDate,
        currentYear: currentYear,
        currentMonth: currentMonth,
        currentDay: currentDay
    };
}
function $55e824ff15c161b3$export$8ada184d5eef4694(birthYear, birthMonth, birthDay) {
    // Get current date
    const { currentDate: currentDate, currentYear: currentYear, currentDay: currentDay } = $55e824ff15c161b3$export$adaf307e533580e2();
    const currentMonth = currentDate.getMonth();
    // Calculate age
    let years = currentYear - birthYear;
    let months = currentMonth - birthMonth;
    let days = currentDay - birthDay;
    // Adjust for negative months or days
    if (days < 0) {
        months--;
        const daysInPreviousMonth = new Date(currentYear, currentMonth, 0).getDate();
        days += daysInPreviousMonth;
    }
    if (months < 0) {
        years--;
        months += 12;
    }
    return {
        years: years,
        months: months,
        days: days
    };
}
$parcel$exportWildcard(module.exports, module.exports);

});


parcelRequire("7nhm9");

//# sourceMappingURL=index.2674591f.js.map
